import React, { useState, useEffect } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import {
  getOutletSellItems,
  saveOutletSellItem,
} from "../../../../../services/sales/outletService";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import ItemSellFormContent from "./ItemSellFormContent";
const itemSellSchema = yup.object().shape({
  data: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
    })
  ),
});
function ItemSellForm({ outletID: outletIDprop = 0, history, match }) {
  const { reload } = useGlobalData();
  const [outletSellItems, setOutletSellItems] = useState([]);
  const [outletID, setOutletID] = useState(0);
  const [outlet, setOutlet] = useState({
    ID: 0,
    currency: { currencyCode: "" },
  });
  async function getItemsPriceData() {
    const outletIDimp = getOutletID();
    if (outletIDimp > 0) {
      setOutletID(outletIDimp);
      getOutletSellItemsData(outletIDimp);
    }
  }
  useEffect(() => {
    getItemsPriceData();
  }, [reload]);

  return (
    <AppForm
      initialValues={{ data: outletSellItems }}
      validationSchema={itemSellSchema}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title:
              "Are you sure want to save this Outlet Item Selling Prices ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveOutletSellItem(values.data).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                getItemsPriceData();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <ItemSellFormContent
        outlet={outlet}
        onReloadItemsSellingPrice={() => {
          getItemsPriceData();
        }}
        history={history}
        outletID={outletID}
      />
    </AppForm>
  );
  async function getOutletSellItemsData(outletID = 0) {
    if (outletID > 0) {
      const response = await getOutletSellItems(outletID);
      const { data } = response.data;
      setOutletSellItems(data.outletSellItems);
      setOutlet(data.outlet);
    }
  }
  function getOutletID() {
    let outletID = 0;
    if (outletIDprop > 0) {
      outletID = outletIDprop;
    } else {
      const { outletID: outletIDparam = 0 } = match.params;
      outletID = parseInt(outletIDparam);
    }
    return outletID;
  }
}

export default ItemSellForm;
